export default __webpack_public_path__ + "static/media/lightdarkmode.19620f9d.png";